import { useContext } from "react";
import { CustomerAuthContext } from "./CustomerAuthContext";

export const useCustomerAuthContext = () => {
    const context = useContext(CustomerAuthContext);
    if(!context){
        throw Error('useCustomerAuthContext must be used inside customer pages');
    }
    return context;
}